module.exports = __webpack_public_path__ + "img/2.8e7e4147.png";